<template lang="pug">
li.user-icons__item
  a.user-icons__item-link(:href='`${footprint.user.url}`')
    span(:class='["a-user-role", primaryRoleClass]')
      img.a-user-icon.is-xs(
        :title='footprint.user.icon_title',
        :alt='footprint.user.icon_title',
        :src='footprint.user.avatar_url',
        :class='loginNameClass')
    // NEXTRIBE: コメント以外は、法人向けの為、名前も表示させる
    span.user-icons__item-name(v-if='this.displayUserName')
      | {{ footprint.user.private_name }}
</template>
<script>
export default {
  props: {
    footprint: { type: Object, required: true },
    displayUserName: { type: Boolean, default: true },
  },
  computed: {
    loginNameClass() {
      return `is-${this.footprint.user.login_name}`
    },
    primaryRoleClass() {
      return `is-${this.footprint.user.primary_role}`
    }
  }
}
</script>
